import { Component } from 'react'

class BrushHandle extends Component<
  { width: number; height: number; cursor: string; x: number; y: number },
  {}
> {
  render() {
    return (
      <svg
        width={this.props.width + 22}
        height={this.props.height}
        cursor={this.props.cursor}
        className="wc-brush__handle"
        x={this.props.x - 10}
        y={this.props.y}
      >
        <g transform="translate(-1261 -2470.858)">
          <path
            d="M0,2V94.1"
            transform="translate(1276.287 2468.858)"
            fill="#fff"
            strokeWidth="1"
          />
          <g transform="translate(1261 2499)" fill="#fff">
            <path
              d="M 15 29.5 C 11.12691020965576 29.5 7.485640048980713 27.99173927307129 4.746950149536133 25.25304985046387 C 2.008260011672974 22.51436042785645 0.5 18.87309074401855 0.5 15 C 0.5 11.12691020965576 2.008260011672974 7.485640048980713 4.746950149536133 4.746950149536133 C 7.485640048980713 2.008260011672974 11.12691020965576 0.5 15 0.5 C 18.87309074401855 0.5 22.51436042785645 2.008260011672974 25.25304985046387 4.746950149536133 C 27.99173927307129 7.485640048980713 29.5 11.12691020965576 29.5 15 C 29.5 18.87309074401855 27.99173927307129 22.51436042785645 25.25304985046387 25.25304985046387 C 22.51436042785645 27.99173927307129 18.87309074401855 29.5 15 29.5 Z"
              stroke="none"
            />
            <path
              d="M 15 1 C 11.26046943664551 1 7.744760513305664 2.456249237060547 5.100509643554688 5.100509643554688 C 2.456249237060547 7.744760513305664 1 11.26046943664551 1 15 C 1 18.73952865600586 2.456249237060547 22.25523948669434 5.100509643554688 24.89949035644531 C 7.744760513305664 27.54375076293945 11.26046943664551 29 15 29 C 18.73952865600586 29 22.25523948669434 27.54375076293945 24.89949035644531 24.89949035644531 C 27.54375076293945 22.25523948669434 29 18.73952865600586 29 15 C 29 11.26046943664551 27.54375076293945 7.744760513305664 24.89949035644531 5.100509643554688 C 22.25523948669434 2.456249237060547 18.73952865600586 1 15 1 M 15 0 C 23.28426933288574 0 30 6.715730667114258 30 15 C 30 23.28426933288574 23.28426933288574 30 15 30 C 6.715730667114258 30 0 23.28426933288574 0 15 C 0 6.715730667114258 6.715730667114258 0 15 0 Z"
              stroke="none"
              fill="#8C8C8C"
            />
          </g>
          <g transform="translate(1153.17 2668.648)">
            <g transform="translate(107.296 -159.648)">
              <path
                d="M110.966-175.507l-2.229,1.286-2.229,1.287a.426.426,0,0,0,0,.737l2.229,1.287,2.229,1.287a.426.426,0,0,0,.639-.369v-5.147A.426.426,0,0,0,110.966-175.507Z"
                transform="translate(-100.296 177.565)"
              />
            </g>
            <g transform="translate(127.78 -157.648)">
              <path
                d="M123.008-169.623l2.229-1.287,2.229-1.287a.426.426,0,0,0,0-.737l-2.229-1.287-2.229-1.286a.425.425,0,0,0-.639.369v5.147A.426.426,0,0,0,123.008-169.623Z"
                transform="translate(-122.369 175.565)"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default BrushHandle
